import React, { useState, useEffect, useMemo } from 'react'
import ClientView from './ClientView'
import { usePickupContext } from '../../context/PickupContext'
const InventoryView = ({
  clients,
  givenOutCodes,
  availableCodes,
  availableMerchandise,
  givenOutMerchandise,
  availablePowerBanks,
  givenOutPowerBanks,
  brandAmbassadors,
  isFetching,
  missions,
  campaigns,
  selectedMerch,
  updateLocalInventoryState,
  updateLocalPowerBankState,
}) => {
  const { pickupContextState } = usePickupContext()
  const [
    codesFilteredBySelectedCodes,
    setCodesFilteredBySelectedCodes,
  ] = useState()
  const {
    showOnlyBooked,
    selectedCodes,
    selectedBrandAmbassadors,
    selectedCampaigns,
    selectedClients,
    selectedMerchTypes,
  } = pickupContextState
  const allCodes = useMemo(() => [...givenOutCodes, ...availableCodes], [
    givenOutCodes,
    availableCodes,
  ])

  const hasSelectedValues =
    selectedBrandAmbassadors ||
    selectedCampaigns ||
    selectedClients ||
    selectedMerchTypes ||
    (selectedCodes && selectedCodes.length && codesFilteredBySelectedCodes)

  useEffect(() => {
    if (selectedCodes && selectedCodes.length && allCodes && allCodes.length) {
      const filteredSelectedCodes = allCodes.filter(
        code =>
          !!selectedCodes.find(selectedCode => selectedCode === code.code),
      )
      const filteredCodes =
        filteredSelectedCodes && filteredSelectedCodes.length
          ? filteredSelectedCodes
          : undefined
      setCodesFilteredBySelectedCodes(filteredCodes)
    } else {
      setCodesFilteredBySelectedCodes()
    }
  }, [selectedCodes, allCodes])

  if (isFetching || !hasSelectedValues)
    return (
      <div style={{ padding: 60, height: '100vh' }}>
        {!hasSelectedValues ? 'Please select filters to start' : 'Loading...'}
      </div>
    )

  var givenOutCodesByClient = {}
  ;(givenOutCodes || []).forEach(code => {
    givenOutCodesByClient[code.clientId] =
      givenOutCodesByClient[code.clientId] || []
    givenOutCodesByClient[code.clientId].push(code)
  })

  var availableCodesByClient = {}
  ;(availableCodes || []).forEach(code => {
    availableCodesByClient[code.clientId] =
      availableCodesByClient[code.clientId] || []
    availableCodesByClient[code.clientId].push(code)
  })

  var availableMerchandiseByClient = {}
  ;(availableMerchandise || []).forEach(item => {
    availableMerchandiseByClient[item.clientId] =
      availableMerchandiseByClient[item.clientId] || []
    availableMerchandiseByClient[item.clientId].push(item)
  })

  var givenOutMerchandiseByClient = {}
  ;(givenOutMerchandise || []).forEach(item => {
    givenOutMerchandiseByClient[item.clientId] =
      givenOutMerchandiseByClient[item.clientId] || []
    givenOutMerchandiseByClient[item.clientId].push(item)
  })

  var availablePowerBanksByClient = {}
  ;(availablePowerBanks || []).forEach(item => {
    availablePowerBanksByClient[item.clientId] =
      availablePowerBanksByClient[item.clientId] || []
    availablePowerBanksByClient[item.clientId].push(item)
  })

  var givenOutPowerBanksByClient = {}
  ;(givenOutPowerBanks || []).forEach(item => {
    givenOutPowerBanksByClient[item.clientId] =
      givenOutPowerBanksByClient[item.clientId] || []
    givenOutPowerBanksByClient[item.clientId].push(item)
  })

  // Filter missions by brandAmbassadors
  var brandAmbassadorsHash = {}
  brandAmbassadors.forEach(ba => (brandAmbassadorsHash[ba.id] = ba))
  missions = missions.filter(m => !!brandAmbassadorsHash[m.userId])

  // Filter missions by campaigns
  var campaignsHash = {}
  campaigns.forEach(c => (campaignsHash[c.id] = c))
  missions = missions.filter(m => !!campaignsHash[m.campaignId])

  const sortedClients = Object.values(
    clients.reduce(
      (acc, client) => {
        const bookedMissions = missions.filter(m => m.isBooked)
        if (bookedMissions.find(bm => bm.clientId === client.id)) {
          acc.withBookedMissions.push(client)
        } else if (!showOnlyBooked) {
          if (
            (givenOutCodesByClient[client.id] &&
              givenOutCodesByClient[client.id].length) ||
            (givenOutMerchandiseByClient[client.id] &&
              givenOutMerchandiseByClient[client.id].length) ||
            (givenOutPowerBanksByClient[client.id] &&
              givenOutPowerBanksByClient[client.id].length)
          ) {
            acc.withoutBookedMissionsButInventoryAssignedToBa.push(client)
          } else {
            acc.withoutBookedMissionsAndNoInventoryAssigned.push(client)
          }
        }
        return acc
      },
      {
        withBookedMissions: [],
        withoutBookedMissionsButInventoryAssignedToBa: [],
        withoutBookedMissionsAndNoInventoryAssigned: [],
      },
    ),
  )
    .reduce((acc, curr) => {
      return [...acc, ...curr]
    }, [])
    .filter(client => {
      if (codesFilteredBySelectedCodes && codesFilteredBySelectedCodes.length) {
        return !!codesFilteredBySelectedCodes.find(
          code => code.clientId === client.id,
        )
      } else {
        return true
      }
    })

  if (!sortedClients.length) {
    return (
      <div style={{ padding: 60, height: '100vh' }}>
        There are no clients available for the selected filters
      </div>
    )
  }

  return sortedClients.map(client => {
    return (
      <ClientView
        updateLocalInventoryState={updateLocalInventoryState}
        updateLocalPowerBankState={updateLocalPowerBankState}
        key={`client-${client.id}`}
        clientName={client.name}
        clientLogo={shimClientLogo(client)}
        cliendId={client.id}
        givenOutCodes={givenOutCodesByClient[client.id]}
        availableCodes={availableCodesByClient[client.id]}
        availableMerchandise={availableMerchandiseByClient[client.id]}
        givenOutMerchandise={givenOutMerchandiseByClient[client.id]}
        availablePowerBanks={availablePowerBanksByClient[client.id]}
        givenOutPowerBanks={givenOutPowerBanksByClient[client.id]}
        ambassadors={brandAmbassadors}
        missions={missions.filter(m => m.clientId == client.id)}
        filterByMerch={selectedMerch}
      />
    )
  })
}

export default InventoryView

/**
 * Returns the client logo, else if one isn't provided uses a third party
 * service to return a url to placeholder image.
 * @param {string} client.logo
 * @param {string} client.name
 * @returns {string} URL of the logo
 */
function shimClientLogo(client) {
  if (client.logo) return client.logo
  return `https://via.placeholder.com/500/3B8000/FFFFFF.png?text=${client.name}`
}
